import { Component, Vue } from 'vue-property-decorator';
import LineItem from '@/services/line_item.ts';
import Shops from '@/services/shops.ts';
import InventoryService from '@/services/inventories.ts';
import SkuService from '@/services/skus.ts';
import { format, isThisISOWeek } from 'date-fns';
import { pickBy as _pickBy } from 'lodash';

@Component({

})
export default class Inventory extends Vue {
  public inventoryService = new InventoryService();
  public skuService = new SkuService();

  public inventories: any[] = [];
  public skus: any[] = [];
  public totalData: number = 0;
  public perPage: number = 50;
  public currentPage: number = 1;
  public isLoading = false;

  public init_query = {
    limit: this.perPage,
    offset: 0,
    supplier_name: '',
    product: '',
    created_at_min: null,
    created_at_max: null,
    dates: null,
  }
  public query: any = JSON.parse(JSON.stringify(this.init_query));

  public async mounted() {
    if (this.$route.query.product) {
      this.query.product = this.$route.query.product;
      await this.fetchInventory();
    } else {
      await this.fetchInventory();
    }
  }

  async fetchInventory(reset = false) {
    if (reset) {
      this.query = JSON.parse(JSON.stringify(this.init_query));
    }
    const query: any = _pickBy({ ...this.query }, (v: any, k: any) => ![null, ''].includes(v));

    if (Array.isArray(query.dates) && query.dates.length === 2) {
      query.created_at_min = format(query.dates[0], 'YYYY-MM-DD 00:00:00+07:00');
      query.created_at_max = format(query.dates[1], 'YYYY-MM-DD 23:59:59+07:00');
    }
    delete query.dates;

    this.isLoading = true;
    try {
      const retrivedInventory: any = await this.inventoryService.index({...query});
      this.inventories = retrivedInventory.inventory;
      const skus = this.inventories.map((inventory: any) => {
        return inventory.sku;
      })
      await this.fetchSku(skus);

      this.totalData = retrivedInventory.total;
    } catch (e) {
      console.log(e)
    } finally {
      this.isLoading = false;
    }
  }

  public async fetchSku(skus: any) {
    this.isLoading = true;
    try {
      const retriveSkus: any = await this.skuService.index({skus: skus});
      this.inventories.forEach((inventory: any) => {
        retriveSkus.skus.forEach((sku: any) => {
          if (sku.sku === inventory.sku) {
            inventory['variant_name'] = sku.variant_name;
          } 
        });
      });
    } catch (e) {
      console.log(e)
    } finally {
      this.isLoading = false;
    }
  }

  public async filter() {
    this.query.offset = 0;
    await this.fetchInventory();
    this.currentPage = 1;
  }

  public async changePage(page: number) {
    if (page === 0) {
      return;
    }
    this.currentPage = page;
    this.query.offset = (this.currentPage - 1) * this.query.limit || 0;
    await this.fetchInventory();
  }
}


